























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import { CashflowMethodGroup } from '@/store/models';

@Component({ components: {} })
export default class CashflowMethod extends Vue {
  @Prop() readonly group!: CashflowMethodGroup;

  selected: any = {};
  showExample: boolean = false;

  @Watch('group', { immediate: true, deep: true })
  onData() {
    if (this.group.Method === 'complete') {
      this.selected = this.items[1];
    } else {
      this.selected = this.items[0];
    }

    this.showExample = this.group.ShowExample;

    this.update();
  }

  @Watch('selected', { immediate: false, deep: true })
  selectedChanged() {
    this.update();
  }

  @Watch('showExample', { immediate: false, deep: true })
  showExampleChanged() {
    this.update();
  }

  update() {
    if (
      this.group.Method === this.selected.id &&
      this.group.ShowExample === this.showExample
    ) {
      return;
    }

    let children: number[];
    if (this.selected.id === 'complete') {
      children = [1001, 1002, 1003, 1004, 1005, 1006, 1007];
    } else {
      children = [1001, 1002, 1003];
    }
    if (this.showExample) {
      children.push(1008);
    }

    const g = {
      Id: this.group.Id,
      Kind: this.group.Kind,
      Type: this.group.Type,
      SubType: this.group.SubType,
      Children: children,
      Method: this.selected.id,
      ShowExample: this.showExample,
    };
    dokument.updateItem(g);
  }

  get items() {
    return [
      {
        id: 'compact',
        label: 'Visa kompakt metodik (3 slides)',
      },
      {
        id: 'complete',
        label: 'Visa komplett metodik (7 slides)',
      },
    ];
  }
}
